export const CONSENT_COOKIE_NAME = 'user_consent'
export const CONSENT_COOKIE_EXPIRES = 365 // jours

// Lit la valeur du cookie de consentement (côté serveur ou client)
// Retourne null si le visiteur n'a pas encore fait de choix
export const parseConsentCookie = (value?: string | null): boolean | null => {
  if (!value) return null

  for (const raw of [value, safeDecode(value)]) {
    try {
      const consent = JSON.parse(raw)
      if (typeof consent?.analytics === 'boolean') return consent.analytics
    }
    catch (error) {
      // valeur non lisible, on essaie la suivante
    }
  }

  return null
}

const safeDecode = (value: string) => {
  try {
    return decodeURIComponent(value)
  }
  catch (error) {
    return value
  }
}
